
<template>
  <v-container fluid>
    <v-toolbar dense>
      <v-icon @click="goBack">chevron_left</v-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title>Fermentation Protocols</v-toolbar-title>
      <v-spacer></v-spacer>
      </v-toolbar>
      <v-data-table pa-0 ma-0
        :headers='headers'
        :items='fermProtocols'
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td center><v-checkbox
                v-model="props.item.active"
                @change="valueChanged(props.item, props.index)"
                hide-details
            ></v-checkbox></td>
            <td @click="itemClicked(props.item, props.index)">{{ props.item.lot}}</td>
            <td @click="itemClicked(props.item, props.index)">{{ props.item.vessel}}</td>
            <td><v-text-field single-line type="text" v-model.number="props.item.brix" @change="numberChanged(props.item, props.index)"></v-text-field></td>
            <td><v-text-field single-line type="text" v-model.number="props.item.temp" @change="numberChanged(props.item, props.index)"></v-text-field></td>
            <td><v-checkbox
                v-model="props.item.dryIce"
                @change="valueChanged(props.item, props.index)"
                hide-details
            ></v-checkbox></td>
            <td><v-checkbox
                v-model="props.item.brixTemp"
                @change="valueChanged(props.item, props.index)"
                hide-details
            ></v-checkbox></td>
            <td><v-select
              @change="valueChanged(props.item, props.index)"
              :items="strength"
              v-model="props.item.pdAM">
            </v-select></td>
            <td><v-text-field @change="valueChanged(props.item, props.index)" single-line type="number" v-model.number="props.item.poAM" ></v-text-field></td>
            <td>
              <v-select
                @change="valueChanged(props.item, props.index)"
                :items="strength"
                v-model="props.item.pdNoon">
              </v-select></td>
            <td><v-text-field @change="valueChanged(props.item, props.index)" single-line type="number" v-model.number="props.item.poNoon" ></v-text-field></td>
            <td>
              <v-select
                @change="valueChanged(props.item, props.index)"
                :items="strength"
                v-model="props.item.pdPM">
              </v-select></td>
            <td><v-text-field @change="valueChanged(props.item, props.index)" single-line type="number" v-model.number="props.item.poPM" ></v-text-field></td>
          </tr>
        </template>
      </v-data-table>
      <!-- <v-btn @click="submitTapped()">SUBMIT BRIX/TEMP UPDATES</v-btn> -->
  </v-container>
</template>

<script>
import axios from 'axios'
import async from 'async'
import myMixins from '../mixins/myMixins'

export default {
  data () {
    return {
      brixTempUpdates: {},
      strength: ['LIGHT', 'MEDIUM', 'HEAVY', 'NONE'],
      headers: [
        { text: 'ACTIVE', value: 'active', sortable: false, width: '25px' },
        { text: 'LOT', value: 'lot', sortable: false, width: '80px' },
        { text: 'VESSEL', value: 'vessel', sortable: false, width: '75px' },
        { text: 'BRIX', value: 'brix', sortable: false, width: '35px' },
        { text: 'TEMP', value: 'temp', sortable: false, width: '35px' },
        { text: 'DRY ICE', value: 'dryIce', sortable: false, width: '25px' },
        { text: 'BRIX/TEMP', value: 'brixTemp', sortable: false, width: '25px' },
        { text: 'AM PD', value: 'pdAM', sortable: false, width: '50px' },
        { text: 'AM PO', value: 'poAM', sortable: false, width: '35px' },
        { text: 'NOON PD', value: 'pdNoon', sortable: false, width: '50px' },
        { text: 'NOON PO', value: 'poNoon', sortable: false, width: '35px' },
        { text: 'PM PD', value: 'pdPM', sortable: false, width: '50px' },
        { text: 'PM PO', value: 'poPM', sortable: false, width: '35px' }
      ],
      fermProtocols: []
    }
  },
  created () {
    this.retrieveAllFermProtocols()
  },
  components:
    {
    },
  computed: {
    isEmpty () {
      for (var key in this.brixTempUpdates) {
        if (this.brixTempUpdates.hasOwnProperty(key)) { return false }
      }
      return true
    },
    vintage () {
      return this.$store.state.vintage
    },
    clientcode () {
      return this.$store.state.client.CODE
    }
  },
  mixins: [myMixins],
  watch: {
    clientcode: function (nv, ov) {
      this.retrieveAllFermProtocols()
    },
    vintage: function (nv, ov) {
      this.retrieveAllFermProtocols()
    }
  },
  methods: {
    submitTapped () {
      axios
        .post(process.env.VUE_APP_BACKEND+'brixtemps?updateAll=true', this.brixTempUpdates)
        .then(response => {
          this.retrieveAllFermProtocols()
        })
    },
    itemClicked (value, index) {
      let vesselComponents = value.vessel.split('-')
      this.$router.push({
        name: 'brixtemps',
        params: {
          lot: value.lot,
          vesselType: vesselComponents[0],
          vesselID: vesselComponents[1]
        }
      })
    },
    brixTempChanged (value, index) {

    },
    numberChanged (value, index) {
      this.brixTempUpdates[value.lot+'_'+value.vessel] = {
        brix: value.brix,
        temp: value.temp
      }
    },
    valueChanged (value, index) {
      console.log(JSON.stringify(value, null, 2))
      axios
        .post(process.env.VUE_APP_BACKEND+'fermprotocols', value)
        .then(response => {
          this.fermProtocols[index].id = response.data.data.id
        })
    },
    retrieveAllFermProtocols () {
      axios
        .get(process.env.VUE_APP_BACKEND+'fermprotocols?year='+ this.vintage + '&clientcode=' + this.clientcode)
        .then(response => {
          this.fermProtocols = []
          response.data.data.forEach(item => {
            this.fermProtocols.push({
              active: (item.status === 'ACTIVE'),
              lot: item.lot,
              clientCode: item.clientCode,
              dryIce: (item.dryIce === 'YES'),
              vessel: item.vesselType + '-' + item.vesselId,
              brix: item.brix,
              temp: item.temp,
              brixTemp: (item.brixTemp === 'YES'),
              pdAM: item.pdAM,
              poAM: item.poAM,
              pdNoon: item.pdNoon,
              poNoon: item.poNoon,
              pdPM: item.pdPM,
              poPM: item.poPM,
              id: item.id
            })
          })
        })
    }
  }
}
</script>
<style>
.v-input {font-size: 12px;}
.v-list__tile__title {font-size: 12px;}
table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child, table.v-table thead td:not(:first-child),
 table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 5px;
}
td {
  vertical-align: center;
}
</style>
